<template>
  <div id="app">
    <div v-if="!hide">
      <md-toolbar class="md-dense">
        <md-button class="md-icon-button" @click="toggleLeftSideNav = true">
          <md-icon>menu</md-icon>
        </md-button>
        <h2 class="md-title" style="flex: 1">Neo-Psy CRM</h2>
      </md-toolbar>
      <md-drawer :md-active.sync="toggleLeftSideNav">
        <md-toolbar class="md-transparent" md-elevation="0">
          <h3 class="md-title">選單</h3>
        </md-toolbar>
        <md-list>
          <md-list-item @click="toggleLeftSideNav = false; $router.push('/patient')" v-if="hasScope('PATIENT_LIST')">
            <md-icon>face</md-icon>
            <span class="md-list-item-next">
              客戶管理
            </span>
          </md-list-item>
          <md-list-item @click="toggleLeftSideNav = false; $router.push('/record')" v-if="hasScope('RECORD_LIST')">
            <md-icon>book</md-icon>
            <span class="md-list-item-next">紀錄管理</span>
          </md-list-item>
          <md-list-item @click="toggleLeftSideNav = false; $router.push('/tag-group')" v-if="hasScope('TAG_UPSERT')">
            <md-icon>label</md-icon>
            <span class="md-list-item-next">標籤類別管理</span>
          </md-list-item>
          <md-list-item @click="toggleLeftSideNav = false; $router.push('/record-template-group')" v-if="hasScope('RECORD_TEMPLATE_UPSERT')">
            <md-icon>label</md-icon>
            <span class="md-list-item-next">服務紀錄範本類別管理</span>
          </md-list-item>
          <md-list-item @click="toggleLeftSideNav = false; $router.push('/item')" v-if="hasScope('ITEM_UPSERT')">
            <md-icon>receipt</md-icon>
            <span class="md-list-item-next">服務項目管理</span>
          </md-list-item>
          <md-list-item @click="toggleLeftSideNav = false; $router.push('/user')" v-if="hasScope('USER_UPSERT')">
            <md-icon>account_circle</md-icon>
            <span>使用者管理</span>
          </md-list-item>
          <md-list-item @click="toggleLeftSideNav = false; $router.push('/location')" v-if="hasScope('LOCATION_UPSERT')">
            <md-icon>location_on</md-icon>
            <span class="md-list-item-next">地點管理</span>
          </md-list-item>
          <md-list-item @click="toggleLeftSideNav = false; $router.push('/role')" v-if="hasScope('ROLE_UPSERT')">
            <md-icon>perm_identity</md-icon>
            <span class="md-list-item-next">角色管理</span>
          </md-list-item>
          <md-list-item @click="toggleLeftSideNav = false; $router.push('/clinic')" v-if="hasScope('CLINIC_UPSERT')">
            <md-icon>perm_identity</md-icon>
            <span class="md-list-item-next">營業地點管理</span>
          </md-list-item>
          <md-list-item @click="toggleLeftSideNav = false; $router.push('/record-overview')" v-if="hasScope('RECORD_OVERVIEW_PERSONAL')">
            <md-icon>book</md-icon>
            <span class="md-list-item-next">匯出工作成果</span>
          </md-list-item>
          <md-list-item @click="toggleLeftSideNav = false; $router.push('/backup')" v-if="hasScope('SYSTEM_OP_BACKUP')">
            <md-icon>book</md-icon>
            <span class="md-list-item-next">備份系統資訊</span>
          </md-list-item>
          <md-list-item @click="logout">
            <md-icon>exit_to_app</md-icon>
            <span class="md-list-item-next">登出</span>
          </md-list-item>
        </md-list>
      </md-drawer>
    </div>
    <router-view/>
    <md-snackbar :md-position="'center'" :md-duration="4000" :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
      <md-button class="md-primary" @click="showSnackbar = false">關閉</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import store from '@/store'
import { hasScope } from '@/services/auth'

export default {
  data: function () {
    return {
      toggleLeftSideNav: false
    }
  },
  store,
  computed: {
    ...mapState('nav', {
      'hide': 'hide'
    }),
    snackbarMessage: function () {
      return store.state.snackbar.message
    },
    showSnackbar: {
      get: function () {
        return store.state.snackbar.show
      },
      set: function () {
        this.$store.commit('snackbar/HIDE')
      }
    }
  },
  created () {
    if (!store.state.auth.user && this.$route.name !== 'OrsTestPatient') {
      this.logout()
    }
  },
  methods: {
    hasScope,
    ...mapMutations('nav', {
      hideNav: 'hide',
      showNav: 'show'
    }),
    ...mapActions('auth', {
      submitLogout: 'SUBMIT_LOGOUT',
      hasPermission: 'hasPermission'
    }),
    logout () {
      this.submitLogout()
      this.hideNav()
      this.$router.push('/login')
    }
  },
  name: 'app'
}
</script>

<style>
.card-container {
  width: 85%;
  margin: 0px auto;
  padding: 1%;
}
@media screen and (max-width: 20px) {
  .card-container {
    width: 100%;
  }
}
#app {
}
input[type="date"]
{
  color: white;
}
.float-right {
  float: right;
}
.pagination {
  /* display: inline-block; */
  display: flex;
  align-content: center;
  justify-content: center;
}

.pagination a {
    color: black;
    float: left;
    padding: 8px 16px;
    text-decoration: none;
}

.pagination a.active {
  background-color: #448aff;
  color: white;
}

.pagination a:hover:not(.active) {background-color: #ddd;}

/* .md-snackbar-content { */
/*   justify-content: center !important; */
/* } */
</style>



// WEBPACK FOOTER //
// src/App.vue